import { useTheme } from '@mui/material'
import { LOCATION_RADIUS } from '../graph/constants'
const SIZE = 26

interface Props extends React.SVGProps<SVGSVGElement> {
  plus?: boolean
  outline?: boolean
  currentColor?: boolean
}

export default function IconTarget({ outline, currentColor, ...props }: Props) {
  const { palette } = useTheme()

  return (
    <svg
      width="38"
      height="38"
      viewBox={`0 0 ${SIZE} ${SIZE}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx={SIZE / 2}
        cy={SIZE / 2}
        r={LOCATION_RADIUS}
        fill={currentColor ? 'currentColor' : palette.contrast.low}
        stroke={palette.background.default}
        vectorEffect="non-scaling-stroke"
        strokeWidth={outline ? 2 : 0}
      />
    </svg>
  )
}
